export default __webpack_public_path__ + "static/media/Elodie 9781408345146.67de623d.jpg";